import memoizeOne from 'memoize-one';
import { createSelector } from 'reselect';

import searchItems from 'utils/searchItems';

import { getDebouncedSearchValue } from 'store/search/selectors';

import { getSystem } from './system.selectors';

const selectExceptionSubCategories = createSelector(
  getSystem,
  ({ exceptionSubCategories }) => exceptionSubCategories || {},
);

const selectExceptionSubCategoriesData = createSelector(
  selectExceptionSubCategories,
  ({ data }) => data || {},
);

export const selectExceptionSubCategoriesList = createSelector(
  selectExceptionSubCategoriesData,
  Object.values,
);

export const selectExceptionSubCategoryById = memoizeOne(id =>
  createSelector(selectExceptionSubCategoriesData, data => data[id]),
);

export const selectFilteredExceptionSubCategoriesList = createSelector(
  [getDebouncedSearchValue, selectExceptionSubCategoriesList],
  searchItems(({ id, name, category }) => [id, name, category]),
);
